module.exports = __webpack_public_path__ + "static/mbn-70522b47f0f77f2ed10d81a19adf0a52.png";